var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-toggle"},[_c('div',{staticClass:"option-container"},_vm._l((_vm.localOptions),function(option,index){return _c('div',{key:index,class:[
                'status-toggle__option',
                {
                    'status-toggle__option--active': option.isSelected,
                    'status-toggle__option--disabled': option.isDisabled
                }
            ],on:{"click":function($event){return _vm.toggleOption(option)}}},[_vm._v(" "+_vm._s(option.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }